interface SegmentConfig {
  enabled: boolean;
  writeKey: string;
}

export function getSegmentConfig(): SegmentConfig {
  return {
    enabled: import.meta.env.FO_ENV !== "local",
    writeKey: import.meta.env.SEGMENT_WEB_WRITE_KEY || "",
  };
}
